import { Input } from "antd";
import { useState } from "react";

export interface DataGridSearchProps {
  value?: string;
  placeholder?: string;
  onSearch: (value: string) => void;
}

export const DataGridSearch = ({ value, placeholder, onSearch }: DataGridSearchProps) => {
  const [inputValue, setInputValue] = useState(value);
  return (
    <Input.Search
      allowClear
      value={inputValue}
      onChange={(e) => setInputValue(e.target.value)}
      placeholder={placeholder}
      onSearch={onSearch}
      size="small"
      className="w-72"
    />
  );
};
